import * as React from 'react';
export var SocialIconFb = function SocialIconFb() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 18",
    width: "9",
    height: "18"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M.063 6.454h1.765V4.74c0-.756.02-1.921.568-2.644C2.975 1.332 3.77.812 5.134.812c2.225 0 3.163.316 3.163.316l-.44 2.615s-.736-.213-1.421-.213c-.686 0-1.302.246-1.302.932v1.992h2.813l-.195 2.553H5.134v8.867H1.828V9.007H.062V6.454z"
  }));
};